'use strict';
var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/path.js
// module id = 217
// module chunks = 0